import { useColorMode, useColorStyle, useTheme } from '@tonic-one/react';

function useTreeStyle() {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const { colors } = useTheme();
  const flexListStyle = {
    appearance: 'none',
    border: '0.0625rem solid',
    color: colors[colorStyle.color.primary],
    outline: 0,
    position: 'relative',
    transition: 'all .2s',
    borderRadius: '3px',
    fontSize: '14px',
    lineHeight: '20px',
    paddingLeft: '12px',
    paddingRight: '12px',
    paddingTop: '12px',
    paddingBottom: '5px',
    // width: '100%',
    backgroundColor: 'transparent',
    borderColor: 'gray:60',
    overflow: 'auto',
  };
  const descriptionStyle = {
    color: colors[colorStyle.color.secondary],
    fontSize: '14px',
    lineHeight: '20px',
    marginTop: '2px',
    marginBottom: '16px',
  };
  // console.log(descriptionStyle);
  const disabledIconColor = {
    color: colorStyle.color.disabled,
  };
  const disabledTextColor = {
    color: colorStyle.color.disabled,
  };
  return {
    flexListStyle,
    descriptionStyle,
    disabledIconColor,
    disabledTextColor,
  };
}

export default useTreeStyle;
